export default "__VITE_ASSET__VgeXWAK1__"